// Легенда драфт-слоя «DEV → Поиск лостов»: классы самокатов и тумблеры подслоёв
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React from 'react';
import {
    onToggleLostSearchShowA,
    onToggleLostSearchShowB,
    onToggleLostSearchShowC,
    onToggleLostSearchShowD1,
    onToggleLostSearchShowD2,
    onToggleLostSearchShowE,
    onToggleLostSearchShowFinish,
    onToggleLostSearchShowRadius,
    onToggleLostSearchShowTheft,
    onToggleLostSearchShowZone,
} from '../../../ac/onChangeMapFilters';
import { LOST_SEARCH_COLORS, LOST_SEARCH_LAYER_ID } from '../../../constants/layers';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const Icon = ({ children }) => (
    <svg
        viewBox="0 0 24 24"
        style={{ display: 'block' }}
    >{children}</svg>
);
const Switch = ({ id, checked, onChange }) => (
    <div>
        <label className={styles.switch}>
            <input
                type='checkbox'
                id={id}
                checked={checked}
                onChange={onChange}
            />
            <span className={classnames(styles.sliderRound, styles.slider)} />
        </label>
    </div>
);
// точка класса — так же, как якорь на карте
const ClassIcon = ({ color }) => (
    <Icon>
        <circle
            cx="12"
            cy="12"
            r="8"
            fill={color}
            stroke="#fff"
            strokeWidth="2"
        />
    </Icon>
);
const RadiusIcon = ({ color }) => (
    <Icon>
        <circle
            cx="12"
            cy="12"
            r="11"
            fill={color}
            fillOpacity="0.12"
            stroke={color}
            strokeWidth="1"
        />
        <circle
            cx="12"
            cy="12"
            r="3"
            fill={color}
        />
    </Icon>
);
const TheftIcon = ({ color }) => (
    <Icon>
        <circle
            cx="12"
            cy="12"
            r="11"
            fill="none"
            stroke={color}
            strokeWidth="2"
        />
        <circle
            cx="12"
            cy="12"
            r="5"
            fill={color}
            stroke="#fff"
            strokeWidth="1.5"
        />
    </Icon>
);
const FinishIcon = ({ color }) => (
    <Icon>
        <circle
            cx="12"
            cy="12"
            r="8"
            fill="#fff"
            stroke={color}
            strokeWidth="3"
        />
    </Icon>
);
const CLASS_ROWS = [
    [ 'A', 'lostSearchShowA', 'Умер на финише' ],
    [ 'B', 'lostSearchShowB', 'Выбросы координат' ],
    [ 'C', 'lostSearchShowC', 'Сместился < 1 км' ],
    [ 'D1', 'lostSearchShowD1', 'Разрядился на финише' ],
    [ 'D2', 'lostSearchShowD2', 'Пропал с зарядом (кража?)' ],
    [ 'E', 'lostSearchShowE', 'Уехал > 1 км' ],
];
const LostSearchLegendComponent = ({
    mapFilters,
    onToggleLostSearchShowA,
    onToggleLostSearchShowB,
    onToggleLostSearchShowC,
    onToggleLostSearchShowD1,
    onToggleLostSearchShowD2,
    onToggleLostSearchShowE,
    onToggleLostSearchShowRadius,
    onToggleLostSearchShowZone,
    onToggleLostSearchShowFinish,
    onToggleLostSearchShowTheft,
}) => {
    const handlers = {
        lostSearchShowA: onToggleLostSearchShowA,
        lostSearchShowB: onToggleLostSearchShowB,
        lostSearchShowC: onToggleLostSearchShowC,
        lostSearchShowD1: onToggleLostSearchShowD1,
        lostSearchShowD2: onToggleLostSearchShowD2,
        lostSearchShowE: onToggleLostSearchShowE,
    };

    return (
        <div>
            <div className={styles.legHead}>{t`Как самокат замолчал:`}</div>
            <div className={classnames(styles.checkboxIconGrid, styles.checkboxIconGridLarge)}>
                {CLASS_ROWS.map(([ cls, key, label ]) => (
                    <React.Fragment key={cls}>
                        <ClassIcon color={LOST_SEARCH_COLORS[cls]} />
                        <label htmlFor={key}>{label}</label>
                        <Switch
                            id={key}
                            checked={mapFilters[key]}
                            onChange={handlers[key]}
                        />
                    </React.Fragment>
                ))}
            </div>
            <div
                className={styles.legHead}
                style={{ marginTop: '8px' }}
            >{t`Показывать:`}</div>
            <div className={classnames(styles.checkboxIconGrid, styles.checkboxIconGridLarge)}>
                <RadiusIcon color={LOST_SEARCH_COLORS.A} />
                <label htmlFor="lostSearchShowZone">{t`Зона поиска вокруг якоря`}</label>
                <Switch
                    id="lostSearchShowZone"
                    checked={mapFilters.lostSearchShowZone}
                    onChange={onToggleLostSearchShowZone}
                />
                <RadiusIcon color={LOST_SEARCH_COLORS.C} />
                <label htmlFor="lostSearchShowRadius">{t`Все круги точности сразу`}</label>
                <Switch
                    id="lostSearchShowRadius"
                    checked={mapFilters.lostSearchShowRadius}
                    onChange={onToggleLostSearchShowRadius}
                />
                <FinishIcon color={LOST_SEARCH_COLORS.A} />
                <label htmlFor="lostSearchShowFinish">{t`Финиш последней поездки`}</label>
                <Switch
                    id="lostSearchShowFinish"
                    checked={mapFilters.lostSearchShowFinish}
                    onChange={onToggleLostSearchShowFinish}
                />
                <TheftIcon color={LOST_SEARCH_COLORS.D2} />
                <label htmlFor="lostSearchShowTheft">{t`Замолчал с зарядом ≥ 30%`}</label>
                <Switch
                    id="lostSearchShowTheft"
                    checked={mapFilters.lostSearchShowTheft}
                    onChange={onToggleLostSearchShowTheft}
                />
            </div>
            <div style={{ marginTop: '6px', fontSize: '0.85em', opacity: 0.8 }}>
                {t`Крупная точка — где искать (медиана последних трёх сигналов), пунктирный круг вокруг неё — зона поиска. Мелкие точки — хвост сигналов перед отключением, линия — их порядок. Полупрозрачные точки улетели от якоря дальше километра: сигнал был, но идти туда не надо. Клик по точке показывает её круг точности, клик по линии прогоняет хвост по порядку.`}
            </div>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, {
    onToggleLostSearchShowA,
    onToggleLostSearchShowB,
    onToggleLostSearchShowC,
    onToggleLostSearchShowD1,
    onToggleLostSearchShowD2,
    onToggleLostSearchShowE,
    onToggleLostSearchShowRadius,
    onToggleLostSearchShowZone,
    onToggleLostSearchShowFinish,
    onToggleLostSearchShowTheft,
})(LostSearchLegendComponent);

export const LostSearchLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    LOST_SEARCH_LAYER_ID
);
